import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document.querySelectorAll(".wp-block-prayer-prayer").forEach((el) => {
	const root = el.querySelector(".prayer__app");
	if (root) {
		createRoot(root).render(<App />);
	}
});
